import { PROVIDER_KEYS_WITH_THEMING } from '../../constants';
export var extractIsSupportTheming = function extractIsSupportTheming(meta) {
  return Boolean((meta === null || meta === void 0 ? void 0 : meta.key) && PROVIDER_KEYS_WITH_THEMING.includes(meta.key));
};